export const TrueBlueFormTypes = {
  SEND_FORM_DATA_START: 'SEND_FORM_DATA_START',
  SEND_FORM_DATA_SUCCESS: 'SEND_FORM_DATA_SUCCESS',
  SEND_FORM_DATA_FAILURE: 'SEND_FORM_DATA_FAILURE',
};
